<app-section-header>
  <h3 prefix>
    <app-section-title [title]="title()"></app-section-title>
  </h3>

  <ng-container suffix *transloco="let t">
    <app-primary-button label="{{t('homePage.showAll')}}" (clicked)="onShowAll()"></app-primary-button>
  </ng-container>
</app-section-header>
